import './resource-show-native-ad.css';
